/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import { wxConfig, wxShare } from "@src/utils/wechat"

const Layout = ({ children, location }) => {
  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])
  return (
    <AppContext.Provider value={{}}>
      <Seo />
      <div className={styles.container}>
        <main>{children}</main>
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
